<template>
    <div class="pagin-wrap">
        <div class="pagin-amount">
            Страница
            <span class="pagin-amount__current">{{ currentPage }}</span>
            из
            <span class="pagin-amount__total">{{ lastPage }}</span>
        </div>
        <div class="pagin-nav">
            <div class="pagin-nav__arrow" :disabled="isFirstPortion" @click.stop="previousPortion">
                <svg class="arrow-prev-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.023 7.96802L1.99946 8.04702M1.99946 8.04702L7.22547 2.97317M1.99946 8.04702L7.3552 13.5634"
                          stroke-width="1.5" />
                </svg>
            </div>

            <div>
              <span v-for="(item, i) in pageList.pages.filter(page => page >= leftPageNumber && page <= rightPageNumber)"
                    :key="i"
                    @click="getPage(item)"
                    :class="{'pagin-nav__current': currentPage === item}">
                    {{item}}
              </span>
            </div>

            <!-- стрелка выпадающего списка -->
            <span @click.stop="toggleList" class="drop-icon pagin-nav__drop-icon" :class="pageList.active ? 'drop-icon_active' : ''">
                <svg class="dropdown-icon" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2"/>
                </svg>
            </span>

            <span v-if="!isLastPortion" 
              @click.stop="getPage(lastPage), portionNumber = portionCount" 
              :class="{'pagin-nav__current': currentPage === lastPage}" 
              style="margin-right: 10px">
              {{ lastPage }}
            </span>

            <div class="pagin-nav__arrow" :disabled="isLastPortion" @click.stop="nextPortion">
                <svg class="arrow-next-icon" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.23486 8.03198L15.2584 7.95298M15.2584 7.95298L10.0323 13.0268M15.2584 7.95298L9.90262 2.43663"
                          stroke-width="1.5" />
                </svg>
            </div>

            <!-- выпадающий список с номерами страниц -->
            <div class="pagin-nav__dropdown" :class="pageList.active ? 'pagin-nav__dropdown_active' : ''">
                <ul class="pagin-nav__list">
                    <li v-for="(item, i) in pageList.pages"
                        :key="i"
                        class="pagin-nav__item"
                        :class="(item === currentPage) ? 'pagin-nav__item_current' : ''"
                        @click="getPage(item), portionNumber = Math.ceil(item / portionSize)"
                    >{{ item }}</li>
                </ul>
            </div>
            <!-- /выпадающий список с номерами страниц -->
        </div>
    </div>
</template>

<script>
export default {
  name: 'the-page-pagination',
  props: {
    pageList: Object,
    firstPage: Number,
    lastPage: Number,
    currentPage: Number,
    disabled: Boolean
  },
  computed: {
    isFirstPortion () {
      return this.portionNumber === 1
    },
    isLastPortion () {
      return this.portionNumber === this.portionCount
    },
    portionCount () {
      return Math.ceil(this.pageList.pages.length / this.portionSize)
    },
    leftPageNumber () {
      return (this.portionNumber - 1) * this.portionSize + 1
    },
    rightPageNumber () {
      return this.portionNumber * this.portionSize
    }
  },
  data () {
    return {
      portionNumber: 1,
      portionSize: 3
    }
  },
  methods: {
    toggleList () {
      this.$emit('toggle-page-list')
    },
    previousPage () {
      this.$emit('prev-page')
    },
    nextPage () {
      this.$emit('next-page')
    },
    previousPortion () {
      --this.portionNumber
    },
    nextPortion () {
      ++this.portionNumber
    },
    getPage (pageNum) {
      this.$emit('get-page', pageNum)
      // this.toggleList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.pagin-wrap {
  display: flex;
  flex-flow: row nowrap;
  user-select: none;

  @media screen and (max-width: $mobile_start)  {
    font-size: 14px;
  }
}

.pagin-amount {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 182px;
  color: $font_color_second;
  margin-right: 20px;

  &__current {
  }

  &__total {
  }
}

.pagin-nav {
  position: relative;
  z-index: 9;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: #95A4C0; // $font_color_second;
  cursor: pointer;

  &__current {
    // margin-right: 10px;
    // margin-left: 10px;
    color: $color_second-light;
  }

  &__drop-icon {
    margin: 0 10px;

    @media screen and (max-width: $tablet_start)  {
      display: none;
    }
  }

  &__arrow {
    color: $color_second-light;
    cursor: pointer;

    &[disabled] {
      color: $color_deactive;
      pointer-events: none;
    }

    &:first-of-type {
      margin-right: 10px;
    }
  }

  &__dropdown {
    position: absolute;
    top: 100%;
    bottom: auto;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding-top: 5px;
    padding-bottom: 5px;
    width: max-content;
    min-width: 36px;
    max-width: 60px;
    background: $color_main;
    border: 1px solid $border_color;
    border-radius: 3px;
    transition: .3s;
    transform: scaleY(0);
    transform-origin: top;

    &_active {
      transform: scaleY(1);
    }

    @media screen and (max-width: $tablet_start)  {
      display: none;
    }
  }

  &__list {
    margin-right: 4px;
    margin-left: 4px;
    padding-right: 4px;
    max-height: 90px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: $border-color;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $color_second-light;
    }
  }

  &__item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;

    &_current {
      color: $color_second-light;
    }
  }
}
</style>
